import { httpClient, getWebApiUrl, getMvcApplicationHeaders } from "@utils";
import { TopTournament } from "@api-types/offer/TopTournament";

class PromoOfferService {
	static getRequestHeaders = () => {
		const appHeaders = getMvcApplicationHeaders();
		// @ts-expect-error
		appHeaders["Content-Type"] = "application/json";
		return appHeaders;
	};

	static async findTopTournaments(
		searchParams: boolean | null = null
	): Promise<TopTournament[]> {
		let url = `${getWebApiUrl()}/api/promo/tournaments`;
		if (searchParams != null) {
			url += `?isFeatured=${String(searchParams)}`;
		}

		return await httpClient.get(url, this.getRequestHeaders(), {
			responseType: "json",
		});
	}
}

export default PromoOfferService;
